import { NotFoundErrorPageView } from "shared/components/empty/NotFoundErrorPageView";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";

export const FundFamilyNotFoundPage: React.FC = () => (
  <PageContent isFullHeight={true}>
    <PageBody data-ls-enabled={true} data-public={true}>
      <NotFoundErrorPageView />
    </PageBody>
  </PageContent>
);
